import { Controller } from "@hotwired/stimulus"

// Shows only the tax fields relevant to the selected provider kind:
//   individual -> Geburtsdatum + Steuer-ID
//   company    -> Firma + USt-ID
// Progressive enhancement: without JS both groups stay visible and the server-side
// (:billing context) validations still enforce the right fields.
export default class extends Controller {
  static targets = ["kind", "individual", "company"]

  connect() {
    this.toggle()
  }

  toggle() {
    const kind = this.kindTargets.find((radio) => radio.checked)?.value
    if (this.hasIndividualTarget) this.individualTarget.hidden = kind !== "individual"
    if (this.hasCompanyTarget) this.companyTarget.hidden = kind !== "company"
  }
}
